import React from 'react';
import templates from './templates';

export const ClockWidget = ({
  template = 'GoldenSynagogue',
  scale = 1,
  bgColor,
  textColor,
  fontFamily,
  accentColor,
}) => {
  const Template = templates[template];
  if (!Template) return <div>Template not found: {template}</div>;
  return (
    <Template
      scale={scale}
      bgColor={bgColor}
      textColor={textColor}
      fontFamily={fontFamily}
      accentColor={accentColor}
    />
  );
};
